export const cards = [{
        title: "Collectibles nerd",
        image: "https://i.ibb.co/Tvsqhb5/funko-Pops.jpg",
        information: "I've been collection toys for about 5 years now, mainly funko pops. I created an Instagram account called lovetheloot where I show my collection.",
        url: "https://www.instagram.com/lovetheloot",
        icon: "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/285/crown_1f451.png",
        label: "@lovetheloot"
    },
    {
        title: "Cat mom",
        image: "https://i.ibb.co/myt0RmM/matthy.jpg",
        information: "I'm a real cat mom and decided to create an instagram account for my cat Matthy. It's full of pictures of the little fur ball.",
        url: "https://www.instagram.com/mister.matthy",
        icon: "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/285/cat-face_1f431.png",
        label: "@mister.matty"
    },
    {
        title: "Traveller",
        image: "https://i.ibb.co/M7Gjf6b/deborah.jpg",
        information: "I love to travel, who doesn't! In 2019 I visited Japan and fell in love with the country. I can't wait to visit Japan again and discover more of Asia.",
        url: "https://www.instagram.com/deborahvdweel",
        icon: "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/285/flag-japan_1f1ef-1f1f5.png",
        label: "@deborahvdweel"
    },
]